module.exports = __webpack_public_path__ + "static/media/Napoli.79e0d9a2.png";